import { render, staticRenderFns } from "./Appeals.vue?vue&type=template&id=72acf10b"
import script from "./Appeals.vue?vue&type=script&lang=js"
export * from "./Appeals.vue?vue&type=script&lang=js"
import style0 from "./Appeals.vue?vue&type=style&index=0&id=72acf10b&prod&lang=scss&module=true"
import style1 from "./Appeals.vue?vue&type=style&index=1&id=72acf10b&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports